// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_04nnz clearfix","comment":"index_comment_y-uGA","pic":"index_pic_tj9sA","v_logo":"index_v_logo_b8iTn","text":"index_text_uavS8","time":"index_time_nN0ub"};